import * as Sentry from "@sentry/browser";
import { buildInitOptions, readDsn } from "../lib/errorTracking";

// レイアウトが DSN を出力しているページでのみ読み込まれる。
// CSP が script-src 'self' のため、SDK は CDN ではなくバンドルに含めて配信する
const dsn = readDsn(document);
if (dsn) {
  Sentry.init({
    ...buildInitOptions(dsn),
    // pageload トランザクションはレイアウトの sentry-trace / baggage meta から
    // サーバー側トレースを引き継ぐ（browserTracingIntegration の既定動作）
    integrations: [Sentry.browserTracingIntegration()],
  });
}
